import React, { useContext } from 'react'

import SummaryImage from './Common/SummaryImage'
import AccommodationSummaryModalFooter from './Common/SummaryModalFooter/AccommodationSummaryModalFooter'
import ReadOnlyItemFooter from './Common/SummaryModalFooter/ReadOnlyItemFooter'
import RestoreCartModalFooter from '../Common/RestoreCartModalFooter'

import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import { OFFER_TYPE_TOUR_V2 } from 'constants/offer'
import AccommodationItemSummaryContent from 'tripPlanner/components/TripModal/TripItems/Summary/AccommodationSummary/AccommodationItemSummaryContent'
import CustomItemSummaryContent from 'tripPlanner/components/TripModal/TripItems/Summary/AccommodationSummary/CustomItemSummaryContent'
import TripContext from 'tripPlanner/contexts/TripContext'
import { useOffer } from 'tripPlanner/hooks/api'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import {
  AccommodationItem,
  AirbnbItem,
  HomeAndVillasItem,
  HotelItem,
} from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { isBookableItem } from 'tripPlanner/utils/bookmark/restoreCart'

interface Props {
  item: AirbnbItem | HotelItem | HomeAndVillasItem | AccommodationItem
}

function AccommodationItemSummary(props: Props) {
  const { item } = props

  const viewAsTemplate = useContext(TripContext)?.viewAsTemplate ?? false
  const { closeModal, goBack } = useModalCallbacks()
  const { data: offer } = useOffer('code' in item ? item.code : undefined)
  const isLEAccommodation =
    offer &&
    offer.parentType !== OFFER_TYPE_TOUR_V2 &&
    offer.parentType !== 'cruise'

  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit
  const isBookable = isLeBookmark(item) && isBookableItem(item)

  return (
    <>
      <ModalHeader
        title={item.place.name}
        subtitle={item.place.region}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <SummaryImage
          place={item.place}
          tripId={item.tripId}
          tripItemId={item.id}
          offer={offer}
        />
        {isLEAccommodation && (
          <AccommodationItemSummaryContent item={props.item} offer={offer} />
        )}
        {!isLEAccommodation && <CustomItemSummaryContent item={props.item} />}
      </ModalBody>

      {!viewAsTemplate && canEdit && (
        <>
          {isBookable && <RestoreCartModalFooter item={item} />}
          {!isBookable && <AccommodationSummaryModalFooter item={item} />}
        </>
      )}
      {!viewAsTemplate && !canEdit && <ReadOnlyItemFooter item={item} />}
    </>
  )
}

export default AccommodationItemSummary
